<template>
    <v-row justify="center">
        <v-dialog v-model="isOpen" @click:outside="$emit('close')" @keydown.esc="$emit('close')" max-width="290">
            <v-card>
                <v-card-title class="headline">{{
                    $t('confirmRestore.title')
                }}</v-card-title>
                <v-card-text>
                    {{ $t('confirmRestore.areYouSure') }}
                </v-card-text>
                <v-card-actions>
                    <v-btn color="red darken-1" text @click="$emit('close')">
                        {{ $t('confirmRestore.cancel') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="$emit('confirm', selected)"
                    >
                        {{ $t('confirmRestore.confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: 'confirmRestore',
    props: {
        isOpen: Boolean,
        selected: Object
    }
};
</script>
